// @ts-nocheck
import { Overlay } from '@angular/cdk/overlay';
import { CdkPortal, TemplatePortal } from '@angular/cdk/portal';
import { NgClass } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import moment from 'moment';
import {
  OverlayHelper,
  overlayUserConfiguration,
} from '../../../../helpers/_old_helpers/overlayHelperClass';
import { ErrorOverlayClass } from '../../error-overlay/error-overlay.directive';
import { InputTextCondensedComponent } from '../input-text-condensed/input-text-condensed.component';

@Component({
  selector: 'lbca-date-picker-condensed',
  templateUrl: './date-picker-condensed.component.html',
  styleUrl: './date-picker-condensed.component.scss',
  imports: [InputTextCondensedComponent, CdkPortal, NgClass],
})
export class DatePickerCondensedComponent implements AfterViewInit, OnDestroy {
  @HostListener('keydown', ['$event'])
  onEsc(event: any) {
    if (event.key === 'Escape') {
      this.closePicker();
    }
  }

  private errorPopup!: ErrorOverlayClass;

  private datePickerOverlay!: OverlayHelper;

  @ViewChild('mainElement', { static: true }) mainElement!: ElementRef;
  @ViewChild('templateAppend', { static: true }) templateAppend!: TemplatePortal;

  public labelValue = '';
  public helperTextValue = '';
  public isRequired = false;
  public isEditable = false;
  public isDisabled = false;
  public isLabeled = false;
  public isTabeled = false;

  public valueInput: any = null;

  public baseMonth = 0;
  public baseYear = 0;

  public baseDate = 'jun de 2019';
  public calendar: any;
  public weekDays: any[] = [];
  public yearMonths: any[] = [];
  public weekSelect;

  public hasError = false;

  public typeSelection: 'calendar' | 'month' = 'calendar';

  @Input('error')
  set err(error) {
    if (error && error.length > 0) {
      this.hasError = true;
      this.errorPopup.setErrors(error);
    } else {
      this.hasError = false;
      this.errorPopup.setErrors([]);
    }
  }

  @Input()
  set value(val: string) {
    if (val) {
      this.valueInput = val;
    }
  }

  @Input() set tabeled(value: boolean) {
    this.isTabeled = value;
  }
  @Input() set labeled(value: boolean) {
    this.isLabeled = !value;
  }
  @Input() set require(status: boolean) {
    this.isRequired = status;
  }
  @Input() set disabled(disabled: boolean) {
    this.isDisabled = disabled;
  }
  @Input() set editable(value: boolean) {
    this.isEditable = value;
  }
  @Input() set helperText(value: string) {
    this.helperTextValue = value;
  }
  @Input() set label(value: string) {
    this.labelValue = value;
  }
  @Input() rules: Array<any> = [];

  @Output('changeValue') changeEmmiter = new EventEmitter();

  @Output() focusState = new EventEmitter();

  @Output('setError') setErrorEmmiter = new EventEmitter();

  @Output('validStatus') validStatusEmmiter = new EventEmitter();

  public componetIconStyle = 'svg-icon-date bg-gray-600 transition duration-400 ease-in-out';

  constructor() {
    const overlay = inject(Overlay);
    const elementRef = inject(ElementRef);

    this.inicializateDate();
    this.datePickerOverlay = new OverlayHelper(overlay);

    this.errorPopup = new ErrorOverlayClass(overlay);
    this.errorPopup.setPosition(
      elementRef,
      [
        {
          originX: 'end',
          originY: 'top',
          overlayX: 'end',
          overlayY: 'bottom',
        },
      ],
      0,
      0,
      'bottom',
      'end'
    );
  }

  ngOnDestroy(): void {
    this.closePicker();
  }

  ngAfterViewInit(): void {
    // USE GET SIZE TO ERRO
    // this.bindProperties.width = Math.round(this.mainElement.nativeElement.getBoundingClientRect().width);

    const config: overlayUserConfiguration = {
      positionStrategy: 'flexible',
      scrollStrategy: 'close',
      connectedTo: this.mainElement,
      flexiblePositionStrategy: [
        {
          originX: 'start',
          originY: 'bottom',
          overlayX: 'start',
          overlayY: 'top',
        },
      ],
    };

    this.datePickerOverlay.setConfiguration(config);
  }

  // Bloqueia clicks dentro do calendario retirar o focus do mesmo
  public eventBlockFocusOut($event) {
    $event.preventDefault();
  }

  public click() {
    const focusedElement = document.activeElement;
    if (focusedElement instanceof HTMLInputElement) {
      this.componetIconStyle =
        'svg-icon-angle bg-primary transition duration-400 ease-in-out rotate-180';
      this.openPickerOverlay();
    }
  }

  public setFocus(focus): void {
    this.focusState.emit(focus);
    if (focus) {
      this.componetIconStyle = 'svg-icon-date bg-primary transition duration-400 ease-in-out';
      this.typeSelection = 'calendar';

      this.openPicker();
    } else {
      this.componetIconStyle = 'svg-icon-date bg-gray-600 transition duration-400 ease-in-out';
      this.closePicker();
    }
  }

  private openPickerOverlay(): void {
    this.datePickerOverlay.show(this.templateAppend);
    this.errorPopup.setFocus(true);
  }

  private closePicker(): void {
    setTimeout(() => {
      this.datePickerOverlay.close();
      this.errorPopup.setFocus(false);
    }, 150);
  }

  private openPicker() {
    // Aqui da scroll para baixo, para certificar que o calendário caiba na página
    const availHeight = Math.round(window.innerHeight);
    const topDistance = Math.round(this.mainElement.nativeElement.getBoundingClientRect().top);

    const spaceDisponible = availHeight - (topDistance + 52);

    if (spaceDisponible < 378) {
      const spaceNecessary = 382 - spaceDisponible;
      const scroll = document.getElementById('main-scroll')!;
      const scrollPosition = Math.round(scroll.scrollTop);
      const newPosition = scrollPosition + spaceNecessary;
      let scrollAnimation = scrollPosition;
      const sumConst = Math.round(spaceNecessary / 100);

      // Suavização do scroll
      let interval;
      interval = setInterval(() => {
        scrollAnimation += sumConst;
        scroll!.scrollTop = scrollAnimation;
      }, 4);

      setTimeout(() => {
        clearInterval(interval);
        scroll.scrollTop = newPosition;
        setTimeout(() => this.openPickerOverlay(), 150);
      }, 402);
    } else {
      setTimeout(() => this.openPickerOverlay(), 150);
    }
  }

  private inicializateDate(): void {
    this.baseMonth = Number(moment().format('MM')) - 1;
    this.baseYear = Number(moment().format('YYYY'));

    this.getDate();
    this.getMonth();

    for (let index = 0; index < 7; index++) {
      const weekDay = moment().startOf('week').add(index, 'day').format('ddd');
      this.weekDays.push({ index: weekDay, label: weekDay.slice(0, 1) });
    }

    for (let index = 0; index < 12; index++) {
      const month = moment().startOf('year').add(index, 'month').format('MMM');
      this.yearMonths.push({ index, label: month });
    }
  }

  private getDate(): void {
    const month = moment().year(this.baseYear).month(this.baseMonth).format('MMMM');
    this.baseDate = `${month}, ${this.baseYear}`;
  }

  public changeMonth(choise): void {
    if (this.typeSelection === 'calendar') {
      if (choise === 'next') {
        if (this.baseMonth > 10) {
          this.baseMonth = 0;
          this.baseYear += 1;
        } else this.baseMonth += 1;
      } else if (choise === 'previus') {
        if (this.baseMonth < 1) {
          this.baseMonth = 11;
          this.baseYear = this.baseYear - 1;
        } else this.baseMonth -= 1;
      }
    } else {
      if (choise === 'next') this.baseYear += 1;
      else this.baseYear -= 1;
    }
    this.getDate();
    this.getMonth();
  }

  private getMonth(): void {
    const date = moment().year(this.baseYear).month(this.baseMonth);
    let startWeek = date.startOf('month').week();
    let endWeek = date.endOf('month').week();
    const lastWeekofYear = date.endOf('year').subtract(1, 'week').week();
    const primeirodia = Number(date.week(startWeek).startOf('week').format('DD'));

    if (primeirodia < 10 && primeirodia > 1) {
      startWeek = startWeek - 1;
    }

    if (endWeek === 1) {
      endWeek = lastWeekofYear;
    }

    const temporaryCalendar: any[] = [];
    for (let week = startWeek; week <= endWeek; week++) {
      if (week < lastWeekofYear) {
        temporaryCalendar.push({
          days: Array(7)
            .fill(0)
            .map((n, i) =>
              date
                .week(week)
                .startOf('week')
                .clone()
                .add(n + i, 'day')
            ),
        });
      } else {
        temporaryCalendar.push({
          days: Array(7)
            .fill(0)
            .map((n, i) =>
              date
                .week(week)
                .startOf('week')
                .clone()
                .add(n + i, 'day')
            ),
        });
        temporaryCalendar.push({
          days: Array(7)
            .fill(0)
            .map((n, i) =>
              moment()
                .year(this.baseYear + 1)
                .month(1)
                .week(1)
                .startOf('week')
                .clone()
                .add(n + i, 'day')
            ),
        });
      }
    }
    this.calendar = temporaryCalendar;
  }

  public getDayMathSelect(day) {
    if (!this.weekSelect) return false;

    if (typeof day === 'string') {
      if (this.weekSelect.format('ddd') === day) return true;
      return false;
    }

    if (this.weekSelect.format('ddd') === day.format('ddd')) {
      if (this.weekSelect.diff(day) > 0) return true;
    }
    return false;
  }

  public changeTypeSelection() {
    if (this.typeSelection === 'calendar') this.typeSelection = 'month';
    else this.typeSelection = 'calendar';
  }

  public selectMonth(month) {
    this.baseMonth = month;
    this.getDate();
    this.getMonth();
    this.changeTypeSelection();
  }

  public selectDay(day) {
    this.weekSelect = null;
    const data = moment(day).format('DD / MM / YYYY');
    this.valueInput = data;

    // this.changeEmmiter.emit(data);
    this.closePicker();
  }

  public change($event) {
    // this.valueInput = moment($event.target.value, "DD / MM / YYYY").format(moment.defaultFormat);

    // if (this.valueInput.length === 25 && moment(this.valueInput, moment.defaultFormat).isValid()) {
    //   this.changeEmmiter.emit(this.valueInput);
    // } else {
    //   this.valueInput = '';
    //   this.changeEmmiter.emit('');
    // }

    this.changeEmmiter.emit($event);
  }
}
